import firebase from 'firebase/app'
import "firebase/auth"
import "firebase/analytics"
import "firebase/database"

const config = {
  apiKey: "AIzaSyAPr79bKRgcaeZLhF6nJhzgUADY008TlEc",
  authDomain: "inversion-shogi-c121c.firebaseapp.com",
  databaseURL: "https://inversion-shogi-c121c.firebaseio.com",
  projectId: "inversion-shogi-c121c",
  storageBucket: "inversion-shogi-c121c.appspot.com",
  messagingSenderId: "697729509794",
  appId: "1:697729509794:web:b01ed5c2624607e6182afb",
  measurementId: "G-W5QCNLW83C"
};

const firebase_app = firebase.initializeApp(config);
firebase_app.analytics();
export const firebase_db = firebase_app.database();
export const firebase_auth = firebase_app.auth();
